<template>
	<div>
		<layout-2 :id=pageid :navbar=true :title="'Add Subcontractor Hours'" :use_radio=false :term=term style="width:100%; height:calc(100vh - 50px);"></layout-2>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.ADD_SUBCONTRACTOR_HOURS_PAGE,
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/add/Add_Subcontractor_Hours.vue